export const SURVEY_QUESTION_TYPES = [
    'scale',
    'short_text',
    'long_text',
    'single_choice',
    'multi_choice',
    'number',
    'boolean',
    'date',
    'file',
    'table',
    'section',
];
/**
 * When a question is shown. It names other questions by their **code**, not their
 * id: an id changes with every copy of the survey, a code does not, so a rule
 * written in a master still points at the right question in every company.
 */
export const CONDITION_OPS = [
    'equals',
    'not_equals',
    'in',
    'not_in',
    'gte',
    'lte',
    'answered',
    'not_answered',
];
export const SHOW_IF_LIMITS = { maxConditions: 5 };
/** What a cell of a table may hold. Deliberately a subset of the question types. */
export const TABLE_COLUMN_TYPES = ['short_text', 'number', 'single_choice', 'multi_choice'];
/**
 * The bounds on a table, kept in one place because the form, the validator and
 * the storage rules all have to agree on them. An answer is stored as one JSON
 * value, so these are also what keeps one row of the database from growing
 * without limit — a public link lets a stranger write one.
 */
export const TABLE_LIMITS = {
    maxColumns: 12,
    maxRowsCap: 50,
    defaultMaxRows: 20,
    maxTextLength: 500,
    maxRowIdLength: 40,
    maxLabelLength: 120,
    maxOptions: 50,
    maxNumber: 1e15,
};
/** A row identifier: stable, written by the system or the author, never reused. */
export const TABLE_ROW_ID_PATTERN = /^[A-Za-z0-9_-]{1,40}$/;
export const TABLE_COLUMN_KEY_PATTERN = /^[a-z][a-z0-9_]{0,29}$/;
/**
 * A question's stable name, chosen by its author: `d3`, `g2`, `nf1`. The id of a
 * question changes with every copy, so whoever reads answers from outside (a
 * scoring script, an agent) needs something that does not. Unique within one
 * survey, repeated freely across companies.
 */
export const QUESTION_CODE_PATTERN = /^[a-z][a-z0-9_]{0,39}$/;
export const SURVEY_RESPONSE_MODES = ['collective', 'individual'];
// --- Public link ---
/** The defaults and ceilings of a public link. */
export const PUBLIC_LINK_LIMITS = {
    /** Answers accepted when the admin does not say: enough for a small panel, too few to flood. */
    defaultMaxResponses: 30,
    maxMaxResponses: 1000,
    maxPrivacyNoticeLength: 4000,
    maxNameLength: 100,
    /** The furthest away an expiry may be: a link left on for years is a link forgotten. */
    maxHorizonDays: 366,
    /** Answers listed to an operator or an agent in one go: the rest are counted, not sent. */
    maxListed: 200,
};
